import React from 'react';
import { THeadingLevel } from 'telia-front-react';
import Config from '../../../Config';
import B2BLoyaltyCard from './B2BLoyaltyCard';

interface B2BLoyaltyLeaseCardProps {
  headingLevel?: THeadingLevel;
}

const B2BLoyaltyLeaseCard = (props: B2BLoyaltyLeaseCardProps): JSX.Element => {
  return <B2BLoyaltyCard icon="#savings" suffix="lease" ctaBaseUrl={Config.teliaShopUrl} headingLevel={props.headingLevel} />;
};

export default B2BLoyaltyLeaseCard;
